import type { GetIcd10CodesResponseBody, Icd10Query } from '@common/interfaces/api/icd10Api';
import { getUrlQueryParameters } from '@frontend/services/api/queryParameterUtils';
import { fetchJson } from '@frontend/store/fetch';

const baseUrl = '/api/dhdThesaurus/icd10Codes';

export async function getIcd10Codes(query: Icd10Query, signal: AbortSignal): Promise<GetIcd10CodesResponseBody> {
    const url = getUrlQueryParameters(baseUrl, query);
    const result = await fetchJson({ method: 'GET', signal, url });

    return result.json;
}
